import React from 'react';
import Link from 'react-router/Link';
import FlatButton from 'material-ui/FlatButton';
import { Card, CardHeader, CardText } from 'material-ui/Card';

const NoAuthorization = (props) => {
  const style = {
    margin: 'auto',
  };

  let userText;


      const btnStyle = {
        color: '#fff'
      }

  if (props.user.role === 'basic-user') {
    userText = (
      <div>
      <p>Please <strong><Link to="/account/subscription">subscribe</Link></strong> to Pronounce Live to gain access.</p>
          <p>Or, if your organization has access, <strong><Link to="/account/join-group">join</Link></strong> its Pronounce Live group.</p>
      </div>
    );
  }

  return (
    <Card style={style}>
      <CardHeader title="Sorry, you have no access to Pronounce Live" />
      <CardText>
        {userText}
      </CardText>
    </Card>
  );
};


export default NoAuthorization;



// WEBPACK FOOTER //
// ./src/components/NoAuthorization.js